import { AttachmentDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation } from '@tanstack/react-query';

export function useGetAttachmentUploadUrl() {
  const api = useApi();

  return useMutation<
    AttachmentDto,
    ExtendedAxiosError,
    { id: string; name: string }
  >({
    mutationKey: ['attachments-upload-url'],
    meta: {
      handleError: true,
    },
    // This is a GET request, but we are using a mutation because
    // we are getting the id when the button is clicked
    mutationFn: ({ id, name }) =>
      api.attachmentsApi.uploadAttachmentUrl(id, name).then((r) => r.data),
  });
}
